import {styled, TableCell, tableCellClasses} from "@mui/material";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
    },
}));
export default function MDTableCell({children, ...rest}) {
    return <StyledTableCell {...rest}>{children}</StyledTableCell>;
}
